<template>
    <div class="account-view">
        <div class="account-view__content">
            <div class="account-view__section">
                <RouterLink to="/login" class="back-button">
                    <SvgIcon
                        icon="icon--directional_arrow-left"
                        class="is-primary-dark"
                    />
                    <span class="ml-2 has-text-primary-dark">
                        {{ $t('account.backToDashboard') }}</span
                    >
                </RouterLink>
                <div class="mb-4 login-form">
                    <h1 class="title is-3 has-text-grey">
                        {{ $t('account.changePasswordForm.header') }}
                    </h1>
                    <h2 class="title is-5 has-text-grey is-uppercase">
                        {{ $t('account.changePasswordForm.chooseNewPassword') }}
                    </h2>
                    <p class="has-text-success is-size-4 status-message">
                        {{ passwordMessage }}
                    </p>
                </div>
            </div>

            <div class="account-view__section has-background-grey-lighter">
                <form class="login-form" @submit.prevent="changePassword">
                    <div class="columns is-multiline is-right">
                        <div class="column is-full">
                            <div class="field">
                                <label class="label is-uppercase mt-3 ml-3">{{
                                    $t('login.inputLabels.oldPassword')
                                }}</label>
                                <div class="control">
                                    <input
                                        v-model="oldPassword"
                                        class="input"
                                        type="password"
                                        pattern="^[\w+\s+0-9]{8,}$"
                                        :placeholder="
                                            $t('login.inputLabels.oldPassword')
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-full">
                            <div class="field">
                                <label class="label is-uppercase mt-3 ml-3">{{
                                    $t('login.inputLabels.newPassword')
                                }}</label>
                                <div class="control">
                                    <input
                                        v-model="newPassword"
                                        class="input"
                                        type="password"
                                        pattern="^[\w+\s+0-9]{8,}$"
                                        :placeholder="
                                            $t('login.inputLabels.newPassword')
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-full">
                            <div class="field">
                                <label class="label is-uppercase mt-3 ml-3">{{
                                    $t('login.inputLabels.repeatPassword')
                                }}</label>
                                <div class="control">
                                    <input
                                        v-model="passwordRepeat"
                                        class="input"
                                        type="password"
                                        :pattern="newPassword"
                                        :placeholder="
                                            $t(
                                                'login.inputLabels.repeatPassword'
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-full login-form__actions">
                            <button
                                :disabled="
                                    !(
                                        newPassword.trim().length > 7 &&
                                        newPassword === passwordRepeat
                                    )
                                "
                                :class="{ 'is-loading': passwordResetPending }"
                                class="button is-primary-dark px-6"
                            >
                                {{
                                    $t(
                                        'account.changePasswordForm.labels.submit'
                                    )
                                }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '../svg/SvgIcon';
import { eventBus } from '../../events/event-bus';
import i18n from '../../i18n';

export default {
    name: 'PasswordUpdate',
    components: { SvgIcon },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            passwordRepeat: '',
            processing: false,
            passwordResetPending: false,
            passwordResetError: false,
        };
    },
    computed: {
        passwordMessage() {
            if (this.passwordResetPending) {
                return this.$i18n.t(
                    'account.changePasswordForm.messages.passwordChangePending'
                );
            }
            if (this.passwordResetSuccessful) {
                return this.$i18n.t(
                    'account.changePasswordForm.messages.passwordChangedSuccessful'
                );
            }
            if (this.newPassword.length === 0) {
                return '';
            } else if (this.newPassword.length < 8)
                return this.$i18n.tc(
                    'account.changePasswordForm.hints.atLeastNCharacters',
                    8
                );
            else {
                if (this.passwordRepeat.length === 0) {
                    return '';
                } else {
                    if (this.passwordRepeat.length >= this.newPassword.length) {
                        if (this.passwordRepeat === this.newPassword) return '';

                        return this.$i18n.t(
                            'account.changePasswordForm.hints.passwordsDontMatch'
                        );
                    }
                }
            }
            return '';
        },
    },
    methods: {
        async changePassword() {
            this.passwordResetPending = true;
            await this.$store.dispatch('changePassword', {
                resetData: {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                },
            });

            eventBus.notification({
                type: 'success',
                header: i18n.t('login.messages.passwordResetSuccess.header'),
                body: i18n.t('login.messages.passwordResetSuccess.body'),
            });

            setTimeout(() => {
                this.$router.push('/login');
            }, 3000);

            this.processing = false;
            this.passwordResetPending = false;
            this.passwordResetSuccessful = true;
            this.newPassword = '';
            this.passwordRepeat = '';
        },
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', { urlSlug: '/' });
        },
    },
    created() {
        this.fetchCMSData();
    },
};
</script>

<style scoped></style>
